import React from 'react'
import { css } from 'emotion'
import styled from 'react-emotion'

import getStarted1 from '../../assets/get-started-1.svg'
import getStarted2 from '../../assets/get-started-2.svg'
import getStarted3 from '../../assets/get-started-3.svg'


const HowItWorksContainer = css`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  margin-bottom: 2rem;
  max-width: 1024px;
  text-align: center;
  
  @media (min-width: 767px) {
    margin-bottom: 0;
    flex-direction: row;
  }
`

const MobileIsometricWrapper = css`
  padding: 4%;
  text-align: center;
  box-sizing: border-box;

  img {
    max-width: 150px;
    height: 170px;
    margin-bottom: 1rem;
  }

  @media (min-width: 767px) {
    width: 33%;
  }

  @media (min-width: 1025px) {
    padding: 2rem;
  }
`

const DescriptionText = styled.p`
  height: 100px;
  text-align: left;
`

const Desc = (props) => (
  <div>
    <h4>{props.header}</h4>
    <DescriptionText>{props.description}</DescriptionText>
  </div>
)

const HowItWorks = (props) => {
  return (
    <div>
      <div className={HowItWorksContainer}>
        <div className={MobileIsometricWrapper}>
          <div>
            <img src={getStarted1} alt="Whistle Dashboard" />
          </div>
            <Desc
              header="Step 1"
              description="Overview of our capabilities, pricing and identifying your properties needs."
            />
        </div>
        <div className={MobileIsometricWrapper}>
          <div>
          <img src={getStarted2} alt="Whistle Dashboard" />
          </div>
            <Desc
              header="Step 2"
              description="Almost instant, integration with your property management system."
            />
        </div>
        <div className={MobileIsometricWrapper}>
          <div>
          <img src={getStarted3} alt="Whistle Dashboard" />
          </div>
            <Desc
              header="Step 3"
              description="Easy, quick, and stress-free training and onboarding."
            />
        </div>
      </div>

    </div>
  )
}
 
export default HowItWorks;


// WEBPACK FOOTER //
// ./src/components/main/HowItWorks.js